<script setup lang="ts">
import { SharedData } from '@/@types'
import pt from '@/assets/flags/brazil.svg'
import esp from '@/assets/flags/spain.svg'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { router, usePage } from '@inertiajs/vue3'
import { computed, onBeforeMount } from 'vue'
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()

function normalizeLocale(lang?: string) {
    if (!lang) return 'pt-BR'

    const normalized = lang.replace('_', '-').toLowerCase()

    if (normalized === 'pt-br') return 'pt-BR'
    if (normalized === 'en-us') return 'en-US'

    return 'pt-BR'
}

const currentFlag = computed(() => {
    switch (locale.value) {
        case 'pt-BR':
            return pt
        case 'en-US':
            return esp
    }
})

const { user } = usePage<SharedData>().props

function handleLangueChange(lang: string) {
    locale.value = normalizeLocale(lang)

    if (!user) return

    router.patch(
        '/locale',
        { user: { locale: lang } },
        {
            preserveState: false,
            only: ['user', 'flash'],
        },
    )
}

onBeforeMount(() => {
    if (user && user.locale) {
        locale.value = normalizeLocale(user.locale)
    }
})
</script>

<template>
    <DropdownMenu>
        <DropdownMenuTrigger class="flex items-center gap-x-2 font-bold text-white uppercase">
            <span class="border-secondary rounded-full border-2">
                <img :src="currentFlag" alt="" />
            </span>
        </DropdownMenuTrigger>
        <DropdownMenuContent class="">
            <DropdownMenuItem
                v-for="lang in $i18n.availableLocales"
                :key="lang"
                class="w-full cursor-pointer"
                as="button"
                @click="handleLangueChange(lang)"
            >
                <img :src="lang === 'pt-BR' ? pt : esp" alt="" />
                {{ lang.toUpperCase() }}
            </DropdownMenuItem>
        </DropdownMenuContent>
    </DropdownMenu>
</template>
